// --- Core ---
import * as Sentry from "@sentry/react";
import {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {useRouteError} from "react-router";
// --- Material UI ---
import {Box, Button, Stack} from "@mui/material";
// --- SaniQ ---
import {useAppDispatch} from "store";
import {setContactFormErrorMessage, setOpenContactForm} from "../../physicians/modules/ticket/actions/ContactForm";
import config from "config";
import bugImage from 'images/illustration/bug_window.png';

const SaniQErrorBoundary = () => {
  const dispatch = useAppDispatch();
  const error = useRouteError();
  const [eventId, setEventId] = useState(null);

  useEffect(() => {
    dispatch(setContactFormErrorMessage(error.stack, eventId));
    return () => {
      dispatch(setContactFormErrorMessage(null));
    };
  }, [dispatch, error.stack, eventId]);

  useEffect(() => {
    const eventId = Sentry.captureException(error);
    setEventId(eventId);
  }, [error]);

  return (
    <Stack
      spacing={2}
      sx={
        {
          alignItems: "center",
          width: "50vw",
          m: "auto"
        }
      }
    >
      <Box sx={{textAlign: "center"}}>
        <FormattedMessage
          id="system.errorBoundary.error_message"
          defaultMessage="<h1>An unexpected error occured</h1> An error occurred in <pn></pn> OS. Please try again later. <br></br>Should this error be reoccurring, please contact our support team and provide following error ID."
        />
      </Box>
      {
        config.appEnv === 'dev' ?
          <>
            <h2><FormattedMessage id="system.errorBoundary.error" defaultMessage="Error message"/></h2>
            <Box sx={{border: 1, borderColor: 'text.primary', borderRadius: 1, m: 1, p: 1}}>
              <p>{`${error.name}: ${error.message}`}</p>
              <pre style={{textWrap: 'wrap'}}>{error.stack}</pre>
            </Box>
          </> :
          <Stack sx={{alignItems: "center"}}>
            <h4><FormattedMessage id="system.errorBoundary.errorId" defaultMessage={"Error ID:"}/> {eventId}</h4>
            <img src={bugImage} width={250}/>
          </Stack>
      }
      <Button
        variant={"contained"} color="primary"
        onClick={
          () => {
            dispatch(setOpenContactForm(true));
          }
        }
      >
        <FormattedMessage id="system.errorBoundary.button" defaultMessage="Contact us now"/>
      </Button>
    </Stack>
  );
};

export {
  SaniQErrorBoundary
};
